import { setClaims, setFilteredClaims } from 'core/store/claimsV2Slice';
import { useAppSelector } from 'core/store/hooks';
import {
  setSelectedPublishedSinceDate,
  setSelectedSourceDate,
} from 'core/store/sourceFilterV2Slice';
import moment from 'moment';
import {
  PublishedSinceDates,
  sortSourcesByDate,
  SourceDates,
} from 'pages/PlaygroundV2Page/helpers';
import { useDispatch } from 'react-redux';

export const useDateFilter = () => {
  const dispatch = useDispatch();
  const claims = useAppSelector((state) => state.claimsV2.claims);
  const filteredClaims = useAppSelector((state) => state.claimsV2.filteredClaims);

  const filterByDate = (sourceDate: SourceDates) => {
    if (sourceDate === SourceDates.MOST_RECENT) {
      return claims.map((claim) => ({
        ...claim,
        evidence: sortSourcesByDate(claim.evidence ?? [], sourceDate),
      }));
    } else {
      return filteredClaims.map((claim) => ({
        ...claim,
        evidence: sortSourcesByDate(claim.evidence ?? [], sourceDate),
      }));
    }
  };

  const updateClaimByDate = (sourceDate: SourceDates) => {
    const sortedClaimsByDate = filterByDate(sourceDate);
    if (sourceDate === SourceDates.MOST_RECENT) {
      dispatch(setClaims(sortedClaimsByDate));
    }
    dispatch(setSelectedSourceDate(sourceDate));
    dispatch(setFilteredClaims(sortedClaimsByDate));
  };

  const updateClaimByPublishedDate = (publishedSinceDate: PublishedSinceDates) => {
    dispatch(setSelectedPublishedSinceDate(publishedSinceDate));
    if (publishedSinceDate === PublishedSinceDates.ANY) {
      dispatch(setFilteredClaims(claims));
    } else {
      const now = moment();
      const startDate = now.clone().subtract(publishedSinceDate, 'months');

      const filterClaimsByPublishDate = filteredClaims.map((claim) => ({
        ...claim,
        evidence: claim.evidence?.filter((e) => moment(e.publishDate).isAfter(startDate)),
      }));

      dispatch(setFilteredClaims(filterClaimsByPublishDate));
    }
  };

  return { updateClaimByDate, updateClaimByPublishedDate };
};

export default useDateFilter;
